<template>
  <div id="BMCampaign">
    <template v-if="campaignType">
      <template v-if="Campaign.length && GoogleAd.length">
        <!-- The Campaign dashboard -->

        <v-layout class="ma-3" v-if="campaignType === 'parent'">
          <v-flex class="flex-row">
            <span class="pf-font-18 font-weight-light">Total Budget:&nbsp;</span>
            <span class="pf-font-18 text-green font-weight-black">$ {{ formatPrice(GoogleAd[0].budget * GoogleAd[0].period) }}</span>
            <span class="pf-font-18 font-weight-light ml-2">Monthly Budget:&nbsp;</span>
            <span class="pf-font-18 text-green font-weight-black">$ {{ formatPrice(GoogleAd[0].budget) }}</span>
            <span class="pf-font-18 font-weight-light ml-2">Spent:&nbsp;</span>
            <span class="pf-font-18 text-green font-weight-black">$ {{ (totalFigures.spent ? formatPrice(totalFigures.spent) : '0.00') }}</span>
          </v-flex>
        </v-layout>

        <v-layout v-if="campaignType === 'parent'" wrap class="ma-3 pt-2 pb-2 pl-3 pr-3 pf-border-hash-2 flex-space-between">
          <v-flex sm3 class="pa-2 flex-start pf-cursor-pointer" @click="isOverviewActive = true">
            <span>
              <v-icon size="24" class="pr-1" :class="{ 'pf-text-teal': isOverviewActive, 'pf-menu-text': !isOverviewActive }">search</v-icon>
            </span>
            <span class="pl-2 pf-font-18" :class="{ 'pf-text-teal border-left-teal-1': isOverviewActive, 'pf-menu-text border-left-hash-1': !isOverviewActive }">Overview</span>
          </v-flex>
          <v-flex sm6 class="pt-2 pb-2 pl-4 pr-4 flex-center pf-bg-dark">
            <v-layout wrap>
              <v-flex xs4>
                <v-layout class="flex-column">
                  <v-flex class="flex-start">
                    <span>
                      <v-icon size="18" color="white" class="pr-2">timelapse</v-icon>
                    </span>
                    <span class="pf-border-left-white-1 pl-2 pf-font-12 pf-text-white">Status</span>
                  </v-flex>
                  <v-flex class="flex-start">
                    <span class="pl-2 pf-font-18 pf-text-white">{{ GoogleAd[0].status }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-layout class="flex-column">
                  <v-flex class="flex-center">
                    <span>
                      <v-icon size="18" color="white" class="pr-2">event</v-icon>
                    </span>
                    <span class="pf-border-left-white-1 pl-2 pf-font-12 pf-text-white">Start Date</span>
                  </v-flex>
                  <v-flex class="flex-center">
                    <span class="pl-2 pf-font-18 pf-text-white">{{ formatDateString(GoogleAd[0].start_date, 'MM/DD/YYYY') }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-layout class="flex-column">
                  <v-flex class="flex-end">
                    <span>
                      <v-icon size="18" color="white" class="pr-2">event</v-icon>
                    </span>
                    <span class="pf-border-left-white-1 pl-2 pf-font-12 pf-text-white">End Date</span>
                  </v-flex>
                  <v-flex class="flex-end">
                    <span class="pl-2 pf-font-18 pf-text-white">{{ formatDateString(GoogleAd[0].end_date, 'MM/DD/YYYY') }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm3 class="pa-2 flex-end pf-cursor-pointer" @click="isOverviewActive = false" >
            <span>
              <v-icon size="24" class="pr-1" :class="{ 'pf-text-teal': !isOverviewActive, 'pf-menu-text': isOverviewActive }">settings</v-icon>
            </span>
            <span class="pl-2 pf-font-18" :class="{ 'pf-text-teal border-left-teal-1': !isOverviewActive, 'pf-menu-text border-left-hash-1': isOverviewActive }">Settings</span>
          </v-flex>
        </v-layout>

        <template v-if="isOverviewActive">
          <v-layout class="ma-3" wrap>
            <v-flex sm4 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-teal">visibility</v-icon>
                <span class="pf-font-24"><b>Impressions</b></span>
                <span class="pf-font-24"><b>{{ totalFigures.impressions ? formatNumber(totalFigures.impressions) : '--' }}</b></span>
                <span class="pf-font-12">Your ads listed</span>
              </div>
            </v-flex>
            <v-flex sm4 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-green">ads_click</v-icon>
                <span class="pf-font-24"><b>Clicks</b></span>
                <span class="pf-font-24"><b>{{ totalFigures.clicks ? formatNumber(totalFigures.clicks) : '--' }}</b></span>
                <span class="pf-font-12">Your ads clicks</span>
              </div>
            </v-flex>
            <v-flex sm4 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-pink">people</v-icon>
                <span class="pf-font-24"><b>Contacts</b></span>
                <span class="pf-font-24"><b>{{ totalFigures.contacts ? formatNumber(totalFigures.contacts) : '--' }}</b></span>
                <span class="pf-font-12">Your contacts</span>
              </div>
            </v-flex>
          </v-layout>

          <v-layout wrap class="ma-3">
            <!-- <v-flex sm4 class="pa-3 flex-column mt-1">
              <span class="pa-2 pf-font-16"><b>Status: </b><i>{{ GoogleAd[0].status }}</i></span>
              <span class="pa-2 pf-font-16"><b>Start Date: </b><i>{{ formatDateString(Campaign[0].start_date, 'MM/DD/YYYY') }}</i></span>
              <span class="pa-2 pf-font-16"><b>Impressions: </b><i>143</i></span>
              <span class="pa-2 pf-font-16"><b>Clicks: </b><i>162</i></span>
              <span class="pa-2 pf-font-16"><b>Contacts: </b><i>89</i></span>
              <span class="pa-2 pf-font-16"><b>Cost per click: </b><i>$12</i></span>
              <span class="pa-2 pf-font-16"><b>Click through rate: </b><i>11.69%</i></span>
              <span class="pa-2 pf-font-16"><b>Budget: </b><i>${{ Campaign[0].budget }} / month</i></span>
            </v-flex> -->
            <v-flex sm12 class="pa-2" v-if="campaignChartData.length > 1">
              <e-chart
                ref="campaignChart"
                :path-option="[
                  ['dataset.source', campaignChartData],
                  ['color', ['#019d8c', '#7ac142', '#f195bf']],
                  ['legend.show', true],
                  ['xAxis.axisLabel.show', true],
                  ['xAxis.type', 'category'],
                  ['yAxis.axisLabel.show', true],
                  ['grid.left', '2%'],
                  ['grid.bottom', '5%'],
                  ['grid.right', '3%'],
                  ['series[0].type', 'bar'],
                  ['series[0].areaStyle', {}],
                  ['series[0].smooth', true],
                  ['series[1].type', 'bar'],
                  ['series[1].areaStyle', {}],
                  ['series[1].smooth', true],
                  ['series[2].type', 'bar'],
                  ['series[2].areaStyle', {}],
                  ['series[2].smooth', true],           
                ]"
                height="400px"
                width="100%"
              ></e-chart>
            </v-flex>
            <v-flex v-else sm12 class="pa-2">
              <h3 class="mt-4 mb-4 pf-text-center">No data available</h3>
            </v-flex>
          </v-layout>
          
          <!-- <v-layout wrap class="mt-3">
            <v-flex sm4 class="pa-3">
              <h4>Ad Configuration</h4>
              <v-flex class="flex-column mt-3">
                <span class="pa-2 pf-font-16"><b>Budget per month: </b><i>${{ Campaign[0].budget }}</i></span>
                <span class="pa-2 pf-font-16"><b>Months: </b><i>3</i></span>
                <span class="pa-2 pf-font-16"><b>Target: </b><i>Florida</i></span>
                <span class="pa-2 pf-font-16"><b>Auto renew: </b><i>ON</i></span>
                <span class="pa-2 pf-font-16"><b>Payment: </b><i>#### #### #### 1234</i></span>
              </v-flex>
            </v-flex>
            <v-flex sm8 class="flex-center">
              <div class="pf-box-shadow pa-5 flex-center">
                <span class="">Video goes here</span>
              </div>
            </v-flex>
          </v-layout> -->
          
          <v-layout class="mt-3 flex-column pa-3" v-if="campaignChartData.length > 1">
            <h4>Detailed Report</h4>
            <v-layout class="flex-spece-between">
              <v-flex class="mb-3">
                <v-btn class="pf-btn pf-bg-teal">
                  <download-excel :data="CampaignFilterReport" :fields="exportFields" :name="exportExcelName">Export to Excel</download-excel>
                </v-btn>
              </v-flex>
              <v-flex class="pr-2">
                <v-daterange
                  ref="dateRange" 
                  v-model="dateRange" 
                  :presets="presets" 
                  display-format="MM/dd/yyyy"
                  :max="new Date().toISOString().substr(0,10)" 
                  :input-props="inputProps"
                  :show-reset="false"
                  @menu-closed="fetchCampaignReport(true)"
                  class="dateRange">
                </v-daterange>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="CampaignFilterReport"
              :search="search"
              class="pf-data-table" 
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                <td>{{ formatDateString(new Date(props.item.date), 'MM/DD/YYYY') }}</td>
                <td>{{ props.item.impression }}</td>
                <td>{{ props.item.clicks }}</td>
                <td>
                  {{ props.item.contacts && props.item.contacts.length ? props.item.contacts.length : 0 }}
                  <a class="ml-2" v-if="props.item.contacts && props.item.contacts.length" href="javascript:void(0)" @click="viewContacts(props.item)">View</a>
                </td>
              </template>
            </v-data-table>
          </v-layout>
        </template>

        <template v-else>
          <!-- Campaign settings -->
          <v-layout class="ma-3" wrap>
            <v-flex sm3 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-teal">timelapse</v-icon>
                <span class="pf-font-24"><b>Status</b></span>
                <span class="pf-font-20">{{ GoogleAd[0].status }}</span>
                <!-- <span class="pf-font-12"><a @click="{}" class="pf-link-disabled">Change campaign status</a></span> -->
              </div>
            </v-flex>
            <v-flex sm3 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-dark">event</v-icon>
                <span class="pf-font-24"><b>Duration</b></span>
                <span class="pf-font-20">{{ GoogleAd[0].period }} months</span>
                <!-- <span class="pf-font-12"><a>Change campaign duration</a></span> -->
              </div>
            </v-flex>
            <v-flex sm3 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-green">my_location</v-icon>
                <span class="pf-font-24"><b>Targets</b></span>
                <span class="pf-font-20">{{ campaignTargets }}</span>
                <span class="pf-font-12"><a @click="changeTarget">Change campaign targets</a></span>
              </div>
            </v-flex>
            <v-flex sm3 class="pa-3 flex-center">
              <div class="flex-column flex-center">
                <v-icon size="40" class="pf-text-pink">sync</v-icon>
                <span class="pf-font-24"><b>Auto Renewal</b></span>
                <v-switch class="ma-0 pa-0" v-model="GoogleAd[0].auto_renew" @change="updateCampaign"></v-switch>
                <span class="pf-font-12 mtm-15">Auto renew the campaign</span>
              </div>
            </v-flex>
          </v-layout>
          <v-layout class="ma-3" wrap>
            <v-flex class="pa-3" sm6>
              <div class="flex-column flex-center">
                <v-icon size="70" color="teal">local_atm</v-icon>
                <span class="pf-font-24"><b>Monthly Budget</b></span>
                <span v-if="GoogleAd[0].budget !== undefined" class="pf-font-20">$ {{ formatPrice(GoogleAd[0].budget) }}</span>
                <span v-else class="pf-font-16 my-3">Not found</span>
                <span class="pf-font-12"><a @click="changeMonthlyBudget" :class="{ 'pf-link-disabled': GoogleAd[0].budget === undefined }">Change monthly budget</a></span>
              </div>
            </v-flex>
            <v-flex class="pa-3" sm6>
              <div class="flex-column flex-center">
                <div class="pf-card-icon-2x mb-2" v-if="GoogleAd[0].current_payment_mode" :style="`background-image:url(/static/cards/${getCardIcon(GoogleAd[0].current_payment_mode.card.type)});`"></div>
                <span class="pf-font-24"><b>Payment Method</b></span>
                <span v-if="GoogleAd[0].current_payment_mode" class="pf-font-20">{{ `${GoogleAd[0].current_payment_mode.card.number.substr(0, 4)} ${GoogleAd[0].current_payment_mode.card.number.substr(4, 4)} ${GoogleAd[0].current_payment_mode.card.number.substr(8, 4)} ${GoogleAd[0].current_payment_mode.card.number.substr(12, 4)}` }}</span>
                <span v-else class="pf-font-16 my-3">Not found</span>
                <span class="pf-font-12"><a @click="GoogleAd[0].status !== 'PENDING' ? changePaymentMethod() : ''" :class="{ 'pf-link-disabled': GoogleAd[0].status === 'PENDING' }">Change payment method</a></span>
              </div>
            </v-flex>
          </v-layout>
        </template>

        <app-modal :active="changeTargetModal" v-if="changeTargetModal" width="50%">
          <div slot="modal-content">
            <v-card>
              <v-toolbar card dark class="pf-bg-teal">
                <v-btn class="pf-modal-close" icon dark @click="closeChangeTargetPopup">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Change Campaign Target</v-toolbar-title>
              </v-toolbar>

              <v-card-text class="mt-4 mb-4">
                <v-form ref="changeTargetForm">
                  <v-layout wrap>
                    <!-- Content -->
                    <v-flex xs12>
                      <v-select
                        v-model="newTargets"
                        :rules="rules.location"
                        label="New Target Location"
                        :items="agencyStates"
                        item-text="name"
                        multiple
                        small-chips
                        deletable-chips
                        @change="isTargetChanged = true"
                        class="required pr-4 pl-4">
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="pf-btn-text-white pf-bg-green"
                  @click="saveNewTarget"
                  :disabled="!newTargets.length"
                >
                  Submit
                </v-btn>
                <v-btn
                  class="pf-btn-text-white pf-bg-pink"
                  @click="closeChangeTargetPopup"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </app-modal>

        <app-modal :active="isChangePaymentMethod" v-if="isChangePaymentMethod" width="40%">
          <div slot="modal-content">
            <v-card>
              <v-toolbar card dark class="pf-bg-teal">
                <v-btn class="pf-modal-close" icon dark @click="closeChangePaymentMethod">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Change Payment Method</v-toolbar-title>
              </v-toolbar>

              <v-card-text class="mt-1 mb-2 pa-4">
                <p class="pf-text-default">Choose your saved cards or add a new one.</p>
                <!-- List cards -->
                <v-layout>
                  <v-flex class="flex-column">
                    <v-radio-group v-model="selectedCardId" @change="cardSelected()" return-object>
                      <v-layout v-for="(card, i) in cards" :key="i">
                        <v-flex class="flex-center">
                          <v-radio
                            :value="card.id"
                            class="flex-center"
                          >
                            <template v-slot:label>
                              <div class="flex-center">
                                <div class="pf-card-icon" :style="`background-image:url(/static/cards/${card.icon});`"></div>
                                #### #### #### {{ card.number.substr(card.number.length - 4) }}
                              </div>
                            </template>
                          </v-radio>
                          <v-flex class="mb-2">
                            <!-- Icons -->
                            <v-btn icon class="ma-0" @click="deleteCard(card)" title="Delete">
                              <v-icon size="20" color="red">delete_outline</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                      <p v-if="!cards.length">No saved cards found.</p>
                    </v-radio-group>
                    <v-btn class="pf-btn pf-btn-save pf-width-50p" @click="addNewCard">
                      <v-icon size="16" class="pr-1">add</v-icon>
                      <div>Add New Card</div>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="pf-btn-text-white pf-bg-green"
                  @click="saveNewPaymentMethod"
                  :disabled="!selectedCardId"
                >
                  Submit
                </v-btn>
                <v-btn
                  class="pf-btn-text-white pf-bg-pink"
                  @click="closeChangePaymentMethod"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </app-modal>

        <!-- Change budget modal -->
        <app-modal :active="isChangeMonthlyBudget" v-if="isChangeMonthlyBudget" width="40%">
          <div slot="modal-content">
            <v-card>
              <v-toolbar card dark class="pf-bg-teal">
                <v-btn class="pf-modal-close" icon dark @click="closeChangePaymentMethod">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Change Monthly Budget</v-toolbar-title>
              </v-toolbar>

              <v-card-text class="mt-1 mb-2 pa-4">
                <v-form ref="changeBudgetForm">
                  <p class="pf-text-default">Your current monthly budget: <b>$ {{ formatPrice(GoogleAd[0].budget) }}</b></p>
                  <v-layout wrap>
                    <v-flex sm6>
                      <v-text-field v-model.number="newBudget.budget" :rules="rules.budget" label="Enter New Monthly Budget" class="required pr-4 pl-4" @input="isBudgetDataChanged = true" prepend-inner-icon="attach_money"></v-text-field>
                    </v-flex>
                    <v-flex sm6 v-if="GoogleAd[0].status === 'ENABLED'">
                      <v-select
                        v-model="newBudget.update_type"
                        label="Choose the subscription type"
                        hint="Select the subscription type"
                        class="required pr-4 pl-4"
                        @change="isBudgetDataChanged = true"
                        :items="[{ text: `Subscribe for another ${GoogleAd[0].period} months`, value: 'total' }, { text: 'Subscribe for the remaining period', value: 'remaining' }]"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="pf-btn-text-white pf-bg-green"
                  @click="saveNewMonthlyBudget"
                  :disabled="!isBudgetDataChanged"
                >
                  Update Budget
                </v-btn>
                <v-btn
                  class="pf-btn-text-white pf-bg-pink"
                  @click="closeChangeMonthlyBudget"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </app-modal>

        <!-- View contacts modal -->
        <app-modal :active="!!currentContacts" v-if="!!currentContacts" width="75%">
          <div slot="modal-content">
            <v-card>
              <v-toolbar card dark class="pf-bg-teal">
                <v-btn class="pf-modal-close" icon dark @click="closeViewContacts">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>View Contacts</v-toolbar-title>
              </v-toolbar>

              <v-card-text class="mt-1 mb-2 pa-4">
                <v-layout>
                  <v-flex class="flex-column">
                    <h4>Contacts</h4>
                      <v-data-table
                        :headers="contactHeaders"
                        :items="currentContacts"
                        :search="contactSearch"
                        class="pf-data-table" 
                        :pagination.sync="contactPagination"
                      >
                        <template v-slot:items="props">
                          <td>{{ props.item.contact_name }}</td>
                          <td>{{ props.item.contact_preference }}</td>
                          <td>
                            <a :href="`mailto:${props.item.email || '#'}`">{{ props.item.email || '--' }}</a>
                          </td>
                          <td width="120">
                            <a :href="`tel:${props.item.phone || '#'}`">{{ props.item.phone || '--' }}</a>
                          </td>
                          <td width="160">{{ props.item.message }}</td>
                          <td>{{ props.item.adoption_choice || '--' }}</td>
                          <td>{{ props.item.location || '--' }}</td>
                          <td>{{ formatDateString(props.item.date, 'MM/DD/YYYY') }}</td>
                        </template>
                      </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="pf-btn-text-white pf-bg-pink"
                  @click="closeViewContacts"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </app-modal>

      </template>
      <template v-else>
        <v-layout class="flex-column">
          <p class="pf-text-default subheading mt-2 mb-2">Select the budget amount and enter your payment information to start running on-line birth mother ads.</p>
          <v-form ref="campaignForm">
            <v-expansion-panel v-model="panelExpand" expand>
              <v-expansion-panel-content>
                <template v-slot:header>
                  <div><h3 class="subheading"><b>1. Plan your Budget</b></h3></div>
                </template>
                <v-card>
                  <v-card-text class="ml-3">

                    <p class="pf-text-default mb-3">Choose your budget, duration and target location to create the ad.</p>

                    <v-layout wrap>
                      <v-flex sm6>
                        <v-layout wrap>
                          <v-flex sm6>
                            <v-text-field v-model.number="BMCampaign.budget" :rules="rules.budget" label="Campaign Budget" class="required pr-4 pl-4" @input="dataChanged" prepend-inner-icon="attach_money"></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <v-text-field v-model.number="BMCampaign.startup_fee" label="Startup Fee" class="pr-4 pl-4" disabled prepend-inner-icon="attach_money"></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <v-text-field v-model.number="BMCampaign.duration" :rules="rules.duration" label="Choose Duration (months)" class="required pr-4 pl-4" @input="updateEndDate"></v-text-field>
                          </v-flex>
                          <v-flex sm6>
                            <v-select
                              v-model="BMCampaign.location"
                              :rules="rules.location"
                              label="Target Location"
                              :items="agencyStates"
                              multiple
                              small-chips
                              item-text="name"
                              disabled
                              class="pr-4 pl-4"
                              @change="dataChanged">
                            </v-select>
                          </v-flex>
                          <v-flex sm6>
                            <v-menu
                              ref="startDateDialog"
                              v-model="startDateModal"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="startDateFormatted"
                                  label="Campaign Start Date"
                                  prepend-icon="event"
                                  v-on="on"
                                  class="pr-4 pl-4"
                                ></v-text-field>
                              </template>
                              <v-date-picker color="#019d8c" :min="new Date().toISOString().substr(0, 10)" v-model="campaignStartDate" @input="startDateModal = false">
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex sm6>
                            <v-menu
                              ref="endDateDialog"
                              v-model="endDateModal"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                              disabled
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="endDateFormatted"
                                  label="Campaign End Date"
                                  readonly 
                                  disabled 
                                  v-on="on"
                                  class="pr-4 pl-4"
                                ></v-text-field>
                              </template>
                              <v-date-picker color="#019d8c" :min="new Date().toISOString().substr(0, 10)" v-model="BMCampaign.endDate"
                              @input="{}">
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex sm6>
                            <v-switch v-model="BMCampaign.auto_renew" class="pr-4 pl-4" label="Auto renew"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex sm6 wrap>
                        <!-- Show the selected budget amounts -->
                        <v-card class="pa-1 ml-3 mr-3">
                          <v-card-text>
                            <h5 class="mb-2">Order Summary</h5>
                            <hr />
                            <table class="mt-2 pf-width-100p">
                              <tr>
                                <th>#</th>
                                <th>Item</th>
                                <th class="pf-text-center">Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                              </tr>
                              <tr class="border-top-dark-1">
                                <td class="pa-1">1.</td>
                                <td class="pa-1">Monthly Budget</td>
                                <td class="pa-1 pf-text-center">{{ BMCampaign.duration }}</td>
                                <td class="pa-1">$ {{ formatPrice(BMCampaign.budget) }}</td>
                                <td class="pa-1">$ {{ formatPrice((BMCampaign.budget * BMCampaign.duration)) }}</td>
                              </tr>
                              <tr class="border-top-dark-1">
                                <td class="pa-1">2.</td>
                                <td class="pa-1">Startup Fee</td>
                                <td class="pa-1 pf-text-center">1</td>
                                <td class="pa-1">$ {{ formatPrice(BMCampaign.startup_fee) }}</td>
                                <td class="pa-1">$ {{ formatPrice(BMCampaign.startup_fee) }}</td>
                              </tr>
                              <tr class="border-top-dark-1">
                                <td></td>
                                <td colspan="3"><b>Grand Total</b></td>
                                <td class="pa-1"><b>$ {{ formatPrice((BMCampaign.budget * BMCampaign.duration) + BMCampaign.startup_fee) }}</b></td>
                              </tr>
                            </table>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap class="flex-column">
                      <v-flex class="flex-start pl-4 mt-2">
                        {{ (isAdEdit ? `Hide` : `Show`) }} &nbsp; <a class="mr-4" @click="toggleAdvancedSettings">Advanced Settings</a>
                      </v-flex>
                      <v-flex v-show="isAdEdit || !BMCampaign.ad.website || !validateUrl(BMCampaign.ad.website)" class="pl-4 pt-3">
                        <p class="pf-text-default mb-3">You can customize your ad here.</p>
                        <v-layout wrap>
                          <v-flex sm4>
                            <v-text-field v-model.trim="BMCampaign.ad.name" :rules="rules.ad.name" label="Ad Name" class="required pr-4 pl-4" @input="dataChanged"></v-text-field>
                          </v-flex>
                          <v-flex sm8>
                            <v-text-field v-model.trim="BMCampaign.ad.website" :rules="rules.ad.website" label="Target Website" class="required pr-4 pl-4" @input="dataChanged" hint="Ex: https://www.example.com" persistent-hint :disabled="campaignType !== 'parent'"></v-text-field>
                          </v-flex>
                        </v-layout>

                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4 ml-4 flex-column">
                      <h5>Terms and Conditions</h5>
                      <v-flex>
                        <v-checkbox class="flex-start ma-2" v-model="BMCampaign.TandC" @change="dataChanged" :rules="rules.TnC">
                          <template v-slot:label>
                            <p class="ma-0">I accept the <a class="cursor-pointer" @click.stop="openTnC">Terms & Conditions</a></p>
                          </template>
                        </v-checkbox>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex xs12 class="button-container pr-4 text-xs-right">
                        <div class="d-inline-flex">
                          <!-- <v-btn class="pf-btn pf-btn-save" @click="submit" v-if="BMCampaign.paymentDone && !isPaymentDisabled">
                            <v-icon size="16" class="pr-1">check_circle</v-icon>
                            <div>Submit Campaign</div>
                          </v-btn> -->
                          <v-btn class="pf-btn pf-btn-save" @click="completedCampaign">
                            <v-icon size="16" class="pr-1">check_circle</v-icon>
                            <div>Continue</div>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content :disabled="isPaymentDisabled">
                <template v-slot:header>
                  <div><h3 class="subheading"><b>2. Payment Method</b></h3></div>
                </template>
                <v-card>
                  <v-card-text class="ml-3">
                    <p class="pf-text-default">Choose your saved cards or add a new one.</p>
                    <v-flex>
                      <div class="d-inline-flex">
                        <p class="pf-font-24"><b>Amount: </b><span>$ {{ formatPrice((BMCampaign.budget * BMCampaign.duration) + BMCampaign.startup_fee) }}</span></p>
                      </div>
                    </v-flex>
                    <v-flex v-if="paymentData && paymentData.status === 'Approved'">
                      <div class="flex-column">
                        <p class="pf-font-24 text-green">Your payment was completed successfully</p>
                        <p class="pf-font-24">Paid amount: <b>$ {{ formatPrice(paymentData.amount) }}</b></p>
                      </div>
                    </v-flex>
                    <!-- List cards -->
                    <v-layout>
                      <v-flex>
                        <v-radio-group v-model="selectedCardId" @change="cardSelected()">
                          <v-layout v-for="(card, i) in cards" :key="i">
                            <v-flex class="flex-center">
                              <v-radio :value="card.id" class="flex-center">
                                <template v-slot:label>
                                  <div class="flex-center">
                                    <div class="pf-card-icon" :style="`background-image:url(/static/cards/${card.icon});`"></div>
                                    #### #### #### {{ card.number.substr(card.number.length - 4) }}
                                  </div>
                                </template>
                              </v-radio>
                              <v-flex class="mb-2">
                                <!-- Icons -->
                                <!-- <v-btn icon class="ma-0" @click="editCard(card)" title="Edit">
                                  <v-icon size="20" color="blue">edit</v-icon>
                                </v-btn> -->
                                <v-btn icon class="ma-0" @click="deleteCard(card)" title="Delete">
                                  <v-icon size="20" color="red">delete_outline</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                          <p v-if="!cards.length">No saved cards found.</p>
                        </v-radio-group>
                        <v-btn class="pf-btn pf-btn-save" @click="addNewCard">
                          <v-icon size="16" class="pr-1">add</v-icon>
                          <div>Add New Card</div>
                        </v-btn>
                      </v-flex>
                      <v-flex>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex xs12 class="button-container pr-4 text-xs-right">
                        <div class="d-inline-flex">
                          <v-btn sm6 class="ml-4 pf-btn pf-btn-save" @click="makePaymentAndContinue" :disabled="!selectedCardId && !BMCampaign.paymentDone">
                            <v-icon size="18" class="pr-1">attach_money</v-icon>
                            <div>{{ !BMCampaign.paymentDone ? 'Make Payment and ' : '' }}Submit</div>
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>

                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <!-- <v-expansion-panel-content>
                <template v-slot:header>
                  <div><h3 class="subheading"><b>3. Create Google Ad</b></h3></div>
                </template>
                <v-card>
                  <v-card-text class="ml-3">

                    <p class="pf-text-default mb-3">You can customize your ad here.</p>

                    <v-layout wrap>
                      <v-flex sm3>
                        <v-text-field v-model.trim="BMCampaign.ad.name" :rules="rules.ad.name" label="Ad Name" class="required pr-4 pl-4" @input="dataChanged"></v-text-field>
                      </v-flex>
                      <v-flex sm6>
                        <v-text-field v-model.trim="BMCampaign.ad.website" :rules="rules.ad.website" label="Target Website" class="required pr-4 pl-4" @input="dataChanged" hint="Ex: https://www.example.com" persistent-hint></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-btn sm6 class="ml-4 pf-btn pf-btn-save" @click="adConfigDone" :disabled="(!BMCampaign.ad.name || !BMCampaign.ad.website || !validateUrl(BMCampaign.ad.website))">
                      <v-icon size="18" class="pr-1">thumb_up</v-icon>
                      <div>Done</div>
                    </v-btn>

                  </v-card-text>
                </v-card>
              </v-expansion-panel-content> -->
            </v-expansion-panel>
          </v-form>
        </v-layout>
        <app-modal :active="TnCModal" v-if="TnCModal" width="70%">
          <div slot="modal-content">
            <v-card>
              <v-toolbar card dark class="pf-bg-teal">
                <v-btn class="pf-modal-close" icon dark @click="TnCModal = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Terms & Conditions</v-toolbar-title>
              </v-toolbar>

              <v-card-text class="mt-4 mb-4">
                <v-layout wrap class="pl-3 pr-3">
                  <v-flex class="wrap-break-word pf-font-16 line-space-25" v-html="`${campaignSettings.TnC ? campaignSettings.TnC : 'No terms and conditions found'}`"></v-flex>
                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="flex-end pr-3">
                <v-btn
                  class="pf-btn-text-white pf-bg-pink"
                  @click="TnCModal = false"
                >
                  Done
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </app-modal>
      </template>
      <!-- Common popup modals -->
      <app-modal :active="showAddCardPopup" v-if="showAddCardPopup" width="30%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="closeAddCardPopup">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Add New Card</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-4 mb-4">
              <v-form ref="newCardForm">
                <v-layout wrap>
                  <!-- Content -->
                  <v-flex xs12>
                    <v-text-field label="Card number" v-model.trim="newCardNumber" :rules="rules.card.number" class="required pr-3 pl-3 flex-center" @input="newCardChange($event)" placeholder="#### #### #### ####" :value="newCard.number" v-mask="'#### #### #### ####'" type="password">
                      <template v-slot:prepend>
                        <v-fade-transition leave-absolute>
                          <div class="pf-card-icon-single" :style="`background-image:url(/static/cards/${newCard.icon});`"></div>
                        </v-fade-transition>
                      </template>
                    </v-text-field>
                    <span v-if="newCardNumberMask" class="pf-pos-relative tm-20 ml-3">Card Number: {{ newCardNumberMask }}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model.trim="newCard.name" :rules="rules.card.name" label="Card holder name" class="required pr-3 pl-3"></v-text-field>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field v-model.trim="newCard.expiry" :rules="rules.card.expiry" label="Expiry date" class="required pr-3 pl-3" v-mask="'## / ##'" placeholder="MM/YY"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-model.trim="dummyCvv" :rules="rules.card.cvv" label="CVV" class="required pr-3 pl-3" v-mask="'####'" type="password" placeholder="CVV"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="saveNewCard"
              >
                Add Card
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeAddCardPopup"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>
    </template>
    <template v-else>
      <!-- Get the campaignType -->
      <v-layout class="mt-4 ml-4 flex-column" v-if="campaignType === null">
        <p class="pf-text-default subheading mb-3">Select the campaign type you prefer to run your profile ad.</p>
        <v-flex xs12 pl-1 pt-0 align-end text-xs-right>
          <v-radio-group class="pt-0 mt-0" v-model="campaignTypeTmp">
            <v-radio v-if="(typeof session.getSession().adminUser !== 'undefined' && (session.getSession().adminUser.role === 'agency' || session.getSession().adminUser.role === 'admin'))" color="teal" label="Adoption Agency Campaign" value="agency"></v-radio>
            <v-radio color="teal" label="Individual Campaign" value="parent"></v-radio>
            <v-radio v-if="(typeof session.getSession().adminUser !== 'undefined' && (session.getSession().adminUser.role === 'agency' || session.getSession().adminUser.role === 'admin'))" color="teal" label="Parentfinder Admin Campaign" value="admin"></v-radio>
          </v-radio-group>
          <v-btn class="pf-btn pf-btn-save flex-start" @click="submitCampaignType">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Continue</div>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>
<script>
/* global session store config */
import AppModal from '../../components/AppModal';
import { mask } from 'vue-the-mask';
import { validateUrl, formatDate, getCardType, request, create, getCollection, getOne, remove, update } from '../../helpers/helpers';

import EChart from '@/components/chart/echart';
import Material from 'vuetify/es5/util/colors';

import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
// import moment from 'moment-timezone';
import moment from 'moment';
moment.tz.setDefault(config.timezone);
import { VDaterange } from 'vuetify-daterange-picker';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';

import JsonExcel from 'vue-json-excel';

import { mapGetters } from 'vuex';

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export default {
  name: 'BMCampaign',
  components: {
    'app-modal': AppModal,
    'upload-btn': UploadButton,
    EChart,
    VDaterange,
    'downloadExcel': JsonExcel
  },
  directives: { mask },
  data: (vm) => ({
    isFormDataChanged: false,
    campaignSettings: null,
    campaignType: null,
    campaignTypeTmp: 'parent',
    adType: 'RESPONSIVE_SEARCH_AD',
    BMCampaign: {
      budget: 99,
      startup_fee: 199,
      duration: 3, // 3 months
      location: [],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().substr(0, 10),
      TandC: true,
      auto_renew: true,
      ad: {
        name: '',
        website: ''
      },
      paymentDone: false
    },
    newCard: {
      name: '',
      number: '',
      expiry: '',
      icon: 'credit-card.ico',
      type: ''
    },
    dummyCvv: '',
    dateRange: { 
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    },
    presets: [
      {
        label: 'Today',
        range: [
          moment().startOf('day').format('YYYY-MM-DD'),
          moment().endOf('day').format('YYYY-MM-DD'),
        ],
      },
      {
        label: 'Yesterday',
        range: [
          moment().add(-1, 'days').format('YYYY-MM-DD'),
          moment().add(-1, 'days').endOf('day').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'This Week',
        range: [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 7 days',
        range: [
          moment().add(-7, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last 15 days',
        range: [
          moment().add(-15, 'days').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'This Month',
        range: [
          moment().startOf('month').format('YYYY-MM-DD'),
          new Date().toISOString().substr(0, 10)
        ]
      },
      {
        label: 'Last Month',
        range: [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
      {
        label: 'Last 3 Month',
        range: [
          moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
      },
    ],
    inputProps: {
      'prepend-icon': 'event',
      'label': 'Date Range'
    },
    CampaignFilterReport: [],
    exportFields: {
      'Date': {
        callback: (value) => {
          return moment(value.date).tz(config.timezone).format('MM/DD/YYYY');
        }
      },
      'Impressions': 'impression',
      'Clicks': 'clicks',
      'Contacts': {
        callback: (value) => {
          return value.contacts && value.contacts.length ? value.contacts.length : 0;
        }
      }
    },
    rules: {
      budget: [
        v => !!v || 'Budget is required',
        v => Number.isInteger(v) || 'Please enter an integer',
        v => !vm.campaignSettings || v >= vm.campaignSettings.min_budget || `Minimum budget should be ${vm.campaignSettings ? vm.campaignSettings.min_budget : ''}`
      ],
      duration: [
        v => !!v || 'Campaign duration is required',
        v => Number.isInteger(v) || 'Please enter an integer',
        v => !vm.campaignSettings || v >= vm.campaignSettings.min_period || `Minimum duration should be ${vm.campaignSettings ? vm.campaignSettings.min_period : ''} months`
      ],
      location: [v => !!v || 'Target location is required'],
      ad: {
        name: [v => !!v || 'Ad name is required'],
        website: [
          v => !!v || 'Target website is required',
          v => v === undefined || v === '' || (validateUrl(v)) || 'Please enter a valid URL',
          v => vm.checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
        ],
        startDate: [v => !!v || 'Ad start date is required']
      },
      card: {
        // number: [v => !!v || 'Card number is required'],
        number: [
          // v => Number.isInteger(v) || 'Please enter an integer',
          // v => v.length <= 16 || 'Card number should not exceed 16 digits'
        ],
        name: [v => !!v || 'Card holder name is required'],
        cvv: [v => !!v || 'CVV is required'],
        expiry: [
          v => !!v || 'Card expiry is required',
          v => vm.validateDateChange(v) || 'Date is invalid or card expired'
        ],
      },
      TnC: [v => !!v || 'Please read and accept the terms and conditions']
    },
    panelExpand: [],
    panelItems: 3,
    selectedCardId: null,
    cards: [],
    showAddCardPopup: false,
    startDateModal: false,
    endDateModal: false,
    TnCModal: false,
    isAdEdit: false,
    cardIcons: [
      { type: 'Visa', icon: 'visa.png' },
      { type: 'Mastercard', icon: 'mastercard.png' },
      { type: 'American Express', icon: 'amex.png' },
      { type: 'Diners Club', icon: 'diners-club.png' },
      { type: 'Discover', icon: 'discover.jpg' },
      { type: 'JCB', icon: 'jcb.png' },
      { type: 'Unknown', icon: 'credit-card.ico' }
    ],
    googleAd: null,
    googleCampaign: null,
    color: Material,
    campaignChartData: [],
    search: '',
    headers: [
      { text: 'Date', value: 'date', align: 'left' },
      { text: 'Impressions', value: 'impression', align: 'left' },
      { text: 'Clicks', value: 'click', align: 'left' },
      { text: 'Contacts', value: 'contacts', align: 'left' }
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'date',
      descending: true
    },
    contactSearch: '',
    contactHeaders: [
      { text: 'Name', value: 'contact_name', align: 'left' },
      { text: 'Type', value: 'contact_preference', align: 'left' },
      { text: 'Email', value: 'email', align: 'left' },
      { text: 'Phone', value: 'phone', align: 'left' },
      { text: 'Message', value: 'message', align: 'left' },
      { text: 'Adoption Choice', value: 'adoption_choice', align: 'left' },
      { text: 'Location', value: 'location', align: 'left' },
      { text: 'Date', value: 'date', align: 'left' }
    ],
    contactPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'date',
      descending: true
    },
    isOverviewActive: true,
    isPaymentDisabled: true,
    paymentData: null,
    campaignStartDate: new Date().toISOString().substr(0, 10),
    startDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    campaignEndDate: null,
    endDateFormatted: null,
    changeTargetModal: false,
    newTargets: [],
    isChangePaymentMethod: false,
    totalFigures: {},
    currentContacts: null,
    campaignTargets: null,
    isTargetChanged: false,
    agencyStates: [], // Only for target updates
    newCardNumber: '',
    newCardNumberMask: '',
    totalReportCount: 0,
    isChangeMonthlyBudget: false,
    isBudgetDataChanged: false,
    newBudget: {
      budget: 0,
      update_type: 'total'
    }
  }),
  computed: {
    ...mapGetters(['Account']),

    PaymentMode: {
      get () {
        return store.state.PaymentMode;
      },
      set (value) {
        store.commit('setPaymentMode', value);
      }
    },
    Campaign: {
      get () {
        return store.state.Campaign;
      },
      set (value) {
        store.commit('setCampaign', value);
      }
    },
    GoogleAd: {
      get () {
        return store.state.GoogleAd;
      },
      set (value) {
        store.commit('setGoogleAd', value);
      }
    },
    CampaignReport: {
      get () {
        return store.state.CampaignReport;
      },
      set (value) {
        store.commit('setCampaignReport', value);
      }
    },
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    exportExcelName () {
      return 'PF_Campaign_Report_' + this.Account.nickname + '_' + (formatDate(new Date(this.dateRange.start), 'MM-DD-YYYY') + '-to-' + formatDate(new Date(this.dateRange.end), 'MM-DD-YYYY') + '_') + moment().tz(config.timezone).format('MMDDYYYY');
    }
  },
  watch: {
    campaignStartDate (val) {
      this.startDateFormatted = this.formatDate(val, 'startDate');
      this.updateEndDate();
    }
  },
  async created () {
    /* Check if campaign and ad already exists */
    if (this.Account.google_campaign && this.Account.google_campaign.campaign) {
      // Back to dashboard if froup campaign
      if (this.Account.google_campaign.type === 'agency') {
        return this.$router.push({ path: '/dashboard' });
      }
      /* Fetch the GoogleAd */
      await this.fetchGoogleAd();
    }
    
    /* Fetch the admin campaign settings */
    await this.fetchCampaignSettings();

    if (this.GoogleAd.length) {
      
      /* Fetch the Campaign */
      await this.fetchCampaign();

      /* Set as individual  */
      if (this.Campaign[0].account) {
        this.campaignType = 'parent';
      } else if (this.Campaign[0].agency) {
        this.campaignType = 'agency';
      } else if (this.Campaign[0].admin) {
        this.campaignType = 'admin';
      }

      /* Fetch the Campaign */
      await this.fetchCampaignReport();

      /* Set the CampaignFilterReport */
      await this.fetchCampaignReport(true);

      /* Set the the total number of reports for the campaign */
      await this.getTotalReportCount();

      /* Set the total figures - impression, clicks and contacts */
      await this.setTotalFigures();

      /* Set the campaignTarget string */
      this.setCampaignTargets();

      if (this.$refs.campaignChart) {
        this.$refs.campaignChart.init(); 
      }

    } else {
      /* Make the first one expanded */
      this.panelExpand = [...Array(this.panelItems).keys()].map((x, i) => i === 0);
  
      /* Fetch the states */
      await this.fetchStates();

      /* Fetch agency state */
      await this.setAgencyState();

      /* Set it by default */
      if (this.campaignSettings) {
        this.BMCampaign.budget = this.campaignSettings.min_budget;
        this.BMCampaign.startup_fee = this.campaignSettings.startup_fee;
        this.BMCampaign.duration = this.campaignSettings.min_period;
        this.BMCampaign.shared_days = this.campaignSettings.shared_days;
      } else {
        this.campaignSettings = {};
        this.campaignSettings.min_budget = this.BMCampaign.budget;
        this.campaignSettings.startup_fee = this.BMCampaign.startup_fee;
        this.campaignSettings.min_period = this.BMCampaign.duration;
        this.BMCampaign.shared_days = 30.4;
      }

      /* Update the endDate */
      this.updateEndDate();

      /* Fetch the payment modes - Cards */
      await this.fetchPaymentModes();
  
      /* Set the card icon based on card type */
      this.setCardIcons();
  
      /* Set the ad fields */
      this.BMCampaign.ad.name = this.Account.ppn;
      if (this.Account.contactInfo && this.Account.contactInfo.website) {
        this.BMCampaign.ad.website = this.Account.contactInfo.website.indexOf('http') > -1 ? this.Account.contactInfo.website : `http://${this.Account.contactInfo.website}`;
      } else {
        this.isAdEdit = true;
      }
    }

    /* Check if already paid */
    await this.fetchPayment();

  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    checkIfNoPFUrl (url) {
      if (url) {
        return url.indexOf('/profile/') === -1/*  && url.split('/').length <= 3 */;
      }
      return false;
    },
    submitCampaignType (e) {
      let texts = {
        'parent': 'This will create a separate campaign for your profile',
        'agency': 'This will add your profile ad to your agency campaign',
        'admin': 'This will add your profile ad to the Parentfinder admin campaign'
      };
      swal.fire({
        title: 'Please confirm',
        text: texts[this.campaignTypeTmp],
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      }).then(async (result) => {
        if (result.value) {
          this.campaignType = this.campaignTypeTmp;
          if (this.campaignType !== 'parent') {
            // this.BMCampaign.ad.website = `${config.adDomain}campaigns/agency/{AgencyUniqueIdentifier}`;
            this.isAdEdit = false;
            /* Refresh the agency states */
            await this.setAgencyState();
          }
        }
      });
    },
    async fetchStates () {
      if (!this.State.length) {
        /* Fetch the US states */
        let { error, data } = await getCollection('State', true, 0, '', { country: '5f0af2eb1b61360afbb1aa0c' });
        if (error) {
          console.log(error);
        } else {
          this.State = data;
        }
      }
    },
    async setAgencyState (isTargetUpdate = false) {
      let agencyId = this.campaignType === 'admin' ? config.admin.id : (this.Account.default_agency ? this.Account.default_agency : (this.Account.agency && this.Account.agency.length ? this.Account.agency[0].agency : null));
      if (agencyId) {
        let { error, data } = await getOne('Agency', agencyId, '', 'address');
        if (error) {
          console.log(error);
        } else {
          if (data.address && data.address.length) {
            this.agencyStates = [];
            for (let j = 0; j < data.address.length; j++) {
              let address = data.address[j];
              if (address && address.state && address.state.name) {
                // eslint-disable-next-line
                if (this.agencyStates.indexOf(address.state.name) === -1) {
                  this.agencyStates.push(address.state.name);
                }
                // eslint-disable-next-line
                if (this.BMCampaign.location.indexOf(address.state.name) === -1) {
                  this.BMCampaign.location.push(address.state.name);
                }
              }
            }
            
            if ((isTargetUpdate && !this.agencyStates.length) || (!isTargetUpdate && !this.BMCampaign.location.length)) {
              swal.fire({
                type: 'warning',
                title: 'Agency state not found.',
                text: 'Your agency state was not found. Please check with your agency to proceed',
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              });
              return;
            }
          }
        }
      }
    },
    async fetchCampaignSettings () {
      let where = { is_super_admin: true };
      let attributes = 'campaign_settings.startup_fee,campaign_settings.admin_fee,campaign_settings.min_period,campaign_settings.shared_days,campaign_settings.min_budget,campaign_settings.TnC';
      let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
      if (error) {
        console.log(error);
      } else if (data.length) {
        data = data[0];
        if (data.campaign_settings && Object.keys(data.campaign_settings).length) {
          this.campaignSettings = data.campaign_settings;
        }
      }
    },
    formatDate (date, type) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      let newDate = `${month}/${day}/${year}`;
      if (type) {
        this.BMCampaign[type] = newDate;
      }
      return newDate;
    },
    formatPrice (value) {
      if (value) {
        let val = Number((value).toFixed(2)).toLocaleString();
        return val.indexOf('.') > -1 ? (val.split('.')[1].length === 1 ? (val + '0') : val) : (val + '.00');
      }
    },
    formatNumber (value) {
      if (value) {
        return Number(value).toLocaleString();
      }
    },
    setCardIcons () {
      this.cards = this.cards.map((x) => {
        let index = this.cardIcons.findIndex(y => y.type === x.type);
        if (x.type && index > -1) {
          x.icon = this.cardIcons[index].icon;
        }
        return x;
      });
    },
    setCampaignTargets () {
      this.campaignTargets = this.Campaign[0].target.filter(x => x.value).map(x => x.value).join(', ');
    },
    async changeTarget () {
      this.changeTargetModal = true;
      if (!this.agencyStates.length) {
        await this.setAgencyState(true);
      }
      /* Set the value as the current one for now */
      this.newTargets = this.Campaign[0].target.map(x => x.value);
    },
    closeChangeTargetPopup () {
      this.changeTargetModal = false;
    },
    async saveNewTarget () {
      if (this.$refs.changeTargetForm.validate()) {
        let newTargetsArray = [];
        if (this.newTargets.length && this.Campaign[0] && this.Campaign[0].id) {
          newTargetsArray = this.newTargets.map(x => {
            return {
              type: 'Location',
              sub_type: 'State',
              value: x
            };
          });
          let data = null;
          let error = null;
          /* Update only the DB if pending, removed or resource not exists */
          if (['PENDING', 'REMOVED'].indexOf(this.Campaign[0].status) > -1 || !this.Campaign[0].resource) {
            this.Campaign[0].target = newTargetsArray;
            // let DBUpdateResponse = await update('Campaign', this.Campaign[0], this.Campaign[0].id);
            // data = DBUpdateResponse.data;
            // error = DBUpdateResponse.error;
            await this.updateCampaign(true);
            return;
          } else {
            /* This will update the DB and the Google server */
            let payload = {
              campaign: this.Campaign[0].id,
              target: newTargetsArray
            };
            let updateResponse = await request('Campaign/UpdateTarget', 'PUT', payload);
            data = updateResponse.data;
            error = updateResponse.error;
          }
          if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
              showConfirmButton: true,
              onClose: () => {
                // 
              }
            });
          } else {
            this.closeChangeTargetPopup();
            this.Campaign[0].target = newTargetsArray;
            this.Campaign = this.Campaign;
            this.setCampaignTargets();

            swal.fire({
              type: 'success',
              title: 'Your campaign targets were changed successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                // 
              }
            });
          }
        }
      }
    },
    setGraphData () {
      this.campaignChartData = [
        ['product', 'Impressions', 'Clicks', 'Contacts']
      ];
      let monthYear = null;
      for (let i = 0; i < this.CampaignReport.length; i++) {
        let item = this.CampaignReport[i];
        monthYear = moment(new Date(item.date)).format('MMM YYYY');
        /* Check if already added */
        // eslint-disable-next-line
        let monthIndex = this.campaignChartData.findIndex(x => x[0] === monthYear);
        if (monthIndex > -1) {
          /* Add all the values */
          this.campaignChartData[monthIndex][1] += item.impression ? parseInt(item.impression, 10) : 0;
          this.campaignChartData[monthIndex][2] += item.clicks ? parseInt(item.clicks, 10) : 0;
          this.campaignChartData[monthIndex][3] += 0;
        } else {
          this.campaignChartData.push([
            monthYear,
            item.impression ? parseInt(item.impression, 10) : 0,
            item.clicks ? parseInt(item.clicks, 10) : 0,
            0
          ]);
        }
      }
      if (this.$refs.campaignChart) {
        this.$refs.campaignChart.init(); 
      }
    },
    viewContacts (item) {      
      let contactIndex = this.CampaignReport.findIndex(x => x.id === item.id);
      if (item && contactIndex > -1 && item.contacts && item.contacts.length) {
        this.currentContacts = item.contacts;        
      }
    },
    closeViewContacts () {
      this.currentContacts = null;
    },
    async changePaymentMethod () {
      this.isChangePaymentMethod = true;

      /* Set the selectedCardId */
      let icon = 'credit-card.ico';
      let iconIndex = this.cardIcons.findIndex(y => y.type === this.GoogleAd[0].current_payment_mode.card.type);
      if (iconIndex > -1) {
        icon = this.cardIcons[iconIndex].icon;
      }
      
      this.selectedCardId = this.GoogleAd[0].current_payment_mode.id;
      /* Fetch the payment modes - Cards */
      await this.fetchPaymentModes();
  
      /* Set the card icon based on card type */
      this.setCardIcons();
    },
    closeChangePaymentMethod () {
      this.isChangePaymentMethod = false;
    },
    changeMonthlyBudget () {
      this.isChangeMonthlyBudget = true;
    },
    closeChangeMonthlyBudget () {
      this.isChangeMonthlyBudget = false;
    },
    async saveNewMonthlyBudget () {
      if (this.$refs.changeBudgetForm.validate()) {
        if (this.isBudgetDataChanged && this.newBudget.budget) {
          let payload = {
            campaign: this.Campaign[0].id,
            account: this.Account.id,
            update_type: this.newBudget.update_type,
            budget: this.newBudget.budget
          };
          let { error, data } = await request('Campaign/UpdateBudget', 'PUT', payload);
          if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
              showConfirmButton: true,
              onClose: () => {
                // 
              }
            });
          } else {
            this.closeChangeMonthlyBudget();
            if (this.campaignType === 'parent') {
              this.Campaign[0].budget = data.budget;
            }
            this.GoogleAd[0].budget = data.budget;

            swal.fire({
              type: 'success',
              title: 'Your cammapgin monthly budget was updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                // 
              }
            });
          }
        }
      }
    },
    async saveNewPaymentMethod () {
      let index = this.cards.findIndex(x => x.id === this.selectedCardId);
      if (this.selectedCardId && index > -1) {
        let payload = {
          campaign: this.Campaign[0].id,
          google_ad: this.GoogleAd[0].id,
          paymentMode: this.selectedCardId,
          campaignType: this.campaignType
        };
        let { error, data } = await request('Campaign/UpdatePaymentMode', 'PUT', payload);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            onClose: () => {
              // 
            }
          });
        } else {
          this.closeChangePaymentMethod();
          if (this.campaignType === 'parent') {
            this.Campaign[0].current_payment_mode = data.campaign && data.campaign.current_payment_mode ? data.campaign.current_payment_mode : this.selectedCardId;
          }
          this.GoogleAd[0].current_payment_mode = data.ad && data.ad.current_payment_mode ? data.ad.current_payment_mode : this.selectedCardId;

          swal.fire({
            type: 'success',
            title: 'Your payment method was changed successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        }
      }
    },
    getCardIcon (cardType) {
      let index = this.cardIcons.findIndex(y => y.type === cardType);
      if (index > -1) {
        return this.cardIcons[index].icon;
      }
      return 'credit-card.ico';
    },
    async fetchPaymentModes () {
      if (!this.PaymentMode.length) {
        let where = { account: this.Account.id };
        let { error, data } = await getCollection('PaymentMode', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.PaymentMode = data;
            /* Set the local card variable */
            this.setCards();
          }
        }
      } else {
        this.setCards();
      }
    },
    async fetchGoogleAd (force = false) {
      if (!this.GoogleAd.length || force) {
        let where = { account: this.Account.id };
        let populate = [{ path: 'payment' }, { path: 'current_payment_mode' }];
        let { error, data } = await getCollection('GoogleAd', true, 0, populate, where);
        if (error) {
          console.log(error);
        } else {
          if (data.length) {
            this.GoogleAd = data;
          }
        }
      }
    },
    async fetchCampaign (force = false) {
      if ((!this.Campaign.length || force) && (this.Account.google_campaign && this.Account.google_campaign.campaign)) {
        let where = { _id: this.Account.google_campaign.campaign };
        let populate = [{ path: 'payment' }, { path: 'current_payment_mode' }];
        let { error, data } = await getCollection('Campaign', true, 0, populate, where);
        if (error) {
          console.log(error);
        } else {
          if (data.length) {
            this.Campaign = data;
          }
        }
      }
    },
    async fetchCampaignReport (fromFilter = false) {
      if (!this.CampaignReport.length || fromFilter) {
        let payload = {
          mode: 'Campaign',
          campaign: this.Campaign[0].id,
          google_ad: this.GoogleAd[0].id,
          account: this.Account.id
        };
        if (fromFilter) {
          if (this.dateRange.start) {
            payload.dateFrom = this.dateRange.start;
          }
          if (this.dateRange.end) {
            payload.dateTo = this.dateRange.end;
          }
        }
        let { error, data } = await request('CampaignReport/ListAggregate', 'POST', payload);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the reports'
          };
        } else { 
          if (!fromFilter) {
            this.CampaignReport = data;

            /* Set the total figures - impression, clicks and contacts */
            this.setTotalFigures();
          } else {
            this.CampaignFilterReport = data;
          }
        }
      }
    },
    setTotalFigures () {
      let spent = 0;
      let impressions = 0;
      let clicks = 0;
      let contacts = 0;
      this.CampaignReport.forEach((item, index) => {
        impressions += parseInt(item.impression, 10);
        clicks += parseInt(item.clicks, 10);
        spent += parseInt(item.cost_micros, 10);
        contacts += item.contacts && item.contacts.length ? item.contacts.length : 0;
      });
      spent = spent / 1000000; // Convert from micros

      // let perDayBudget = Math.floor((this.GoogleAd[0].budget / (this.campaignSettings.shared_days || 30.4)) * 100) / 100;
      let adminPercentage = this.campaignSettings.admin_fee / 100;
      let familyPercentage = 1 - adminPercentage;

      spent = spent / familyPercentage;

      this.totalFigures = { spent, impressions, clicks, contacts };

      /* Refresh the graph data */
      this.setGraphData();

    },
    async getTotalReportCount () {
      let where = {
        // mode: 'Campaign',
        campaign: this.Campaign[0].id,
        google_ad: this.GoogleAd[0].id,
        account: this.Account.id
      };
      let { error, data, count } = await request('CampaignReport/Count', 'GET', {}, null, where);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to fetch the report count'
        };
      } else {
        this.totalReportCount = count;
      }
    },
    async fetchPayment () {
      let where = { account: this.Account.id, payment_type: 'Campaign' };
      let { error, data } = await getCollection('Payment', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data && data.length) {
          this.paymentData = data[0];
          this.BMCampaign.paymentDone = true;
          this.isPaymentDisabled = false;
        }
      }
    },
    setCards () {
      this.cards = this.PaymentMode.map(mode => {
        mode.card.icon = 'credit-card.ico';
        mode.card.id = mode.id;
        return mode.card;
      });
    },
    dataChanged () {
      /* Switch into the next step automatically */
      this.isFormDataChanged = true;
    },
    openTnC () {
      this.TnCModal = true;
    },
    updateEndDate () {
      /* Set the end date */
      if (this.BMCampaign.startDate && this.BMCampaign.duration) {
        let date = new Date(this.BMCampaign.startDate);
        date = new Date(date.setMonth(date.getMonth() + this.BMCampaign.duration));
        this.campaignEndDate = date.toISOString().substr(0, 10);
        this.endDateFormatted = this.formatDate(date.toISOString().substr(0, 10), 'endDate');
      }
    },
    switchPanels (switchToIndex) {
      this.panelExpand = [...Array(this.panelItems).keys()].map((x, i) => i === switchToIndex);
    },
    toggleAdvancedSettings () {
      // this.switchPanels(2);
      if (!this.isAdEdit || (this.BMCampaign.ad.website && this.BMCampaign.ad.name)) {
        this.isAdEdit = !this.isAdEdit;
      } else {
        this.$refs.campaignForm.validate();
      }
    },
    newCardChange (newValue) {
      this.newCard.number = newValue.replace(/ /g, '');
      if (this.newCard.number && this.newCard.number.trim() && this.newCard.number.replace(' ', '')) {
        let cardType = getCardType(this.newCard.number.replace(' ', ''));
        let index = this.cardIcons.findIndex(y => y.type === cardType);
        if (index > -1) {
          this.newCard.icon = this.cardIcons[index].icon;
          this.newCard.type = cardType;
        }
      }
      this.newCardNumberMask = this.newCard.number.replace(' ', '').replace(/.(?=.{4})/g, '#').match(/.{1,4}/g).join(' ');
    },
    formatDateString (date, format) {
      return formatDate(date, format);
    },
    cardSelected () {
      // 
    },
    addNewCard () {
      /* Close the popup if requested from settings */
      if (this.isChangePaymentMethod) {
        this.closeChangePaymentMethod();
      }
      this.showAddCardPopup = true;
      this.dummyCvv = '';
    },
    validateDateChange (value) {
      if (value && value.trim()) {
        let splited = this.newCard.expiry.trim().split(' / ');
        if (parseInt(splited[0], 10) > 12 || parseInt(splited[0], 10) < 1) {
          return false;
        }
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;
        let lastTwo = currentYear.toString().substr(2);
        if (parseInt(splited[1], 10) < lastTwo || (parseInt(splited[1], 10) === lastTwo && currentMonth)) {
          return false;
        }
      }
      return true;
    },
    closeAddCardPopup () {
      this.showAddCardPopup = false;
      this.newCardNumber = '';
      this.newCardNumberMask = '';
      this.newCard = {
        name: '',
        number: '',
        expiry: '',
        icon: 'credit-card.ico',
        type: ''
      };
      /* Open the change payment method popup if request comes from there */
      if (!this.isOverviewActive) {
        this.changePaymentMethod();
      }
    },
    completedCampaign () {
      if (this.$refs.campaignForm.validate()) {
        this.isPaymentDisabled = false;
        this.switchPanels(1);
      } else {
        this.isAdEdit = true;
      }
    },
    async saveNewCard () {
      if (this.$refs.newCardForm.validate()) {
        if (this.newCard) {
          let payload = { card: JSON.parse(JSON.stringify(this.newCard)) };
          delete payload.card.icon;
          /* format the card number and expiry */
          payload.card.number = payload.card.number.replace(/ /g, '');
          payload.card.expiry = payload.card.expiry.replace(' / ', '');
          payload.card.type = payload.card.type ? payload.card.type : 'Unknown';
          payload.account = this.Account.id;
          let { error, data } = await create('PaymentMode', payload);
          if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
              showConfirmButton: true,
              onClose: () => {
                this.newCard = {
                  name: '',
                  number: '',
                  expiry: '',
                  icon: 'credit-card.ico',
                  type: ''
                };
              }
            });
          } else if (data) {
            this.PaymentMode.push(data);
            this.setCards();
            this.setCardIcons();
            
            let cardType = getCardType(data.card.number);
            let index = this.cardIcons.findIndex(y => y.type === cardType);
            let icon = 'credit-card.ico';
            if (cardType && index > -1) {
              icon = this.cardIcons[index].icon;
            }
            this.newCard = {
              name: '',
              number: '',
              expiry: '',
              icon: 'credit-card.ico',
              type: ''
            };
            this.showAddCardPopup = false;
            /* Set the authorize_profile in account if not exists */
            if (!this.Account.authorize_profile && data.authorizeNetProfile) {
              this.Account.authorize_profile = data.authorizeNetProfile;
            }
            /* If card added from settings, ask the user if the new card should be selected as the payment method */
            if (!this.isOverviewActive) {
              swal.fire({
                title: 'Set Payment Method',
                text: 'Your card was added successfully, do you want to set this new card as your default payment method?',
                type: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, I do!',
                cancelButtonText: 'No'
              }).then(async (result) => {
                if (result.value) {
                  this.selectedCardId = data.id;
                  /* Sleep for 2 seconds */
                  await sleep(4000);
                  /* Call the change payment method API */
                  await this.saveNewPaymentMethod();
                } else {
                  /* Open the change payment method popup again */
                  this.isChangePaymentMethod = true;
                }
              });
            } else {
              this.selectedCardId = data.id;
              swal.fire({
                type: 'success',
                title: 'Your card was added successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  // 
                }
              });
            }
          }
        }
      }

    },
    // eslint-disable-next-line
    async makePaymentAndContinue () {
      /* Return if campaign already exists */
      if ((this.Account.google_campaign && this.Account.google_campaign.campaign && this.Campaign.length) || !this.campaignType) {
        return false;
      }
      if (this.campaignType === 'agency' && !this.Account.default_agency) {
        swal.fire({
          type: 'warning',
          title: 'No default agency',
          text: 'No default agency found for your profile, please set a default agency and try',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      /* Submit the payment and campaign */
      if (!this.Account.authorize_profile || !this.Account.authorize_profile.customer_id) {
        swal.fire({
          type: 'warning',
          title: 'No customer profile',
          text: 'No customer profile found on authorize.net, please try again',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      if (!this.BMCampaign.paymentDone && !this.selectedCardId) {
        swal.fire({
          type: 'warning',
          title: 'No payment method',
          text: 'Please choose a payment method to proceed',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      if (this.$refs.campaignForm.validate()) {
        let submitPayload = {
          account: this.Account.id,
          name: `${this.Account.ppn && this.Account.ppn.length > 2 ? this.Account.ppn : this.Account.nickname}${process.env.NODE_ENV !== 'production' ? ` - ${process.env.NODE_ENV}` : ''}`,
          payment_mode: this.selectedCardId ? this.selectedCardId : this.paymentData.payment_mode,
          amount: (this.BMCampaign.budget * this.BMCampaign.duration) + this.BMCampaign.startup_fee,
          period: this.BMCampaign.duration,
          budget: this.BMCampaign.budget,
          authorize_profile_id: this.Account.authorize_profile.customer_id,
          auto_renew: this.BMCampaign.auto_renew,
          ad_type: this.adType,
          ad_data: {
            start_date: new Date(this.BMCampaign.startDate).toISOString(),
            end_date: new Date(this.BMCampaign.endDate).toISOString()
          },
          website: this.BMCampaign.ad.website,
          campaignType: this.campaignType,
          default_agency: this.Account.default_agency
        };
        if (this.BMCampaign.location.length) {
          submitPayload.target = this.BMCampaign.location.map(location => {
            return {
              type: 'Location',
              sub_type: 'State',
              value: location
            };
          });
        }
        // let { error, data } = await request('Payment/CampaignPayment', 'POST', submitPayload);
        let { error, data: submitData } = await request('Payment/SubmitCampaign', 'POST', submitPayload);
        if (error) {
          swal.fire({
            type: 'warning',
            title: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            onClose: () => {
              return;
            }
          });
          return;
        } else {
          /* Payment */
          if (submitData.payment) {
            this.BMCampaign.paymentDone = true;
            this.paymentData = submitData.payment;
          }

          /* Campaign */
          if (submitData.campaign) {
            this.Account.google_campaign = {
              campaign: submitData.campaign._id,
              type: this.campaignType,
              payment: this.paymentData._id,
              current_payment_mode: this.paymentData.payment_mode
            };
            this.Campaign.push(submitData.campaign);
          }
          /* Set the campaignTarget string */
          this.setCampaignTargets();

          /* Ad */
          /* Fetch the GoogleAd */
          await this.fetchGoogleAd(true);
          /* Fetch the Campaign */
          await this.fetchCampaign(true);

          /* Create the timeline */
          let timelineData = {
            title: 'Requested Campaign',
            text: `The Google campaign was requested`,
            account: this.Account.id,
            type: 'campaignRequested'
          };
          let { error, data, status } = await create('Timeline', timelineData);
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Failed to create the timeline'
            };
          }

          swal.fire({
            type: 'success',
            title: 'Done',
            text: 'Your payment was successfully completed and submitted the campaign',
            showConfirmButton: true,
            timer: 2500,
            onClose: async () => {
              this.switchPanels(0);
            }
          });
        }
      } else {
        this.isAdEdit = true;
      }
    },
    async submit () {
      /*
        Steps
          1. Submit button
          2. Validate the fields - 3 sections */
      try {
        let campaignId = null;
        if (this.$refs.campaignForm.validate()) {
          if (this.BMCampaign.paymentDone && this.paymentData) {
            if (!this.Account.google_campaign || !this.Account.google_campaign.campaign || !this.Campaign.length) {
              let campaignPayload = {
                account: this.Account.id,
                name: `${this.Account.ppn && this.Account.ppn.length > 2 ? this.Account.ppn : this.Account.nickname}${process.env.NODE_ENV !== 'production' ? ` - ${process.env.NODE_ENV}` : ''}`,
                budget: this.BMCampaign.budget,
                /* target: [{
                  type: 'Location',
                  sub_type: 'State',
                  value: this.BMCampaign.location
                }], */
                start_date: new Date(this.BMCampaign.startDate).toISOString(),
                end_date: new Date(this.BMCampaign.endDate).toISOString(),
                period: this.BMCampaign.duration,
                auto_renew: this.BMCampaign.auto_renew,
                payment: this.paymentData.id,
                current_payment_mode: this.paymentData.payment_mode
              };
              if (this.BMCampaign.location.length) {
                campaignPayload.target = this.BMCampaign.location.map(location => {
                  return {
                    type: 'Location',
                    sub_type: 'State',
                    value: location
                  };
                });
              }
              let { error, data: campaignData } = await create('Campaign', campaignPayload);
              if (error) {
                this.selectedData = true;
                console.log('error', error);
              } else {
                campaignId = campaignData._id;
                this.Account.google_campaign = {
                  campaign: campaignId,
                  type: this.campaignType,
                  payment: this.paymentData._id,
                  current_payment_mode: this.paymentData.payment_mode
                };
                this.Campaign.push(campaignData);
              }
            } else {
              campaignId = this.Account.google_campaign.campaign;
            }

            if (!campaignId) {
              swal.fire({
                type: 'warning',
                title: 'Campaign not found',
                text: 'There was no campaign found or failed to create.',
                showConfirmButton: true,
                timer: 2500,
                onClose: () => {
                  return;
                }
              });
              return;
            }
            
            /* Create the google ad */
            let adPayload = {
              account: this.Account.id,
              campaign: campaignId,
              name: `${this.Account.ppn && this.Account.ppn.length > 2 ? this.Account.ppn : this.Account.nickname}${process.env.NODE_ENV !== 'production' ? ` - ${process.env.NODE_ENV}` : ''}`,
              website: this.BMCampaign.ad.website
            };
            let { error, data: adData } = await create('GoogleAd', adPayload);
            if (error) {
              this.selectedData = true;
              console.log('error', error);
            } else {
              /* Fetch the GoogleAd */
              await this.fetchGoogleAd(true);
              /* Fetch the Campaign */
              await this.fetchCampaign(true);

              /* Create the timeline */
              let timelineData = {
                title: 'Requested Campaign',
                text: `The Google campaign was requested`,
                account: this.Account.id,
                type: 'campaignRequested'
              };
              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              }
              
              swal.fire({
                type: 'success',
                title: 'Campaign Created',
                text: 'GoogleAd campaign was created successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  // 
                }
              });
            }
          } else {
            swal.fire({
              type: 'warning',
              title: 'Payment Error',
              text: 'Please complete the payment before you submit the campaign',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                // 
              }
            });
          }
        } else {
          /* Toggle advanced setitngs */
          this.isAdEdit = true;
        }
      } catch (error) {
        console.log('error', error);
        swal.fire({
          type: 'warning',
          title: 'Error',
          text: 'Something went wrong, please try again. If problem persists please contact support at support@parentfinder.com',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      /*
          3. Check if payment was done - Ask to do payment before if not
          4. Create the campaign for the family
          5. Create the ad for the family campaign
          6. Show the dashboard to the family on the ad status and budget
      */
    },
    async updateCampaign (isTargetUpdate = false) {
      try {
        let payload = JSON.parse(JSON.stringify(this.Campaign[0]));
        payload.payment = payload.payment.id;
        payload.current_payment_mode = payload.current_payment_mode.id;
        let { error, data } = await update('Campaign', payload, payload.id);
        if (error) {
          console.log('error', error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            timer: 2500,
            onClose: () => {
              return;
            }
          });
          return;
        } else {
          
          if (isTargetUpdate) {
            this.closeChangeTargetPopup();
            this.Campaign = this.Campaign;
            this.setCampaignTargets();
          }

          swal.fire({
            type: 'success',
            title: 'Campaign Updated',
            text: 'Campaign was updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        }
      } catch (error) {
        console.log('error', error);
        swal.fire({
          type: 'warning',
          title: 'Error',
          text: 'Something went wrong, please try again. If problem persists please contact support at support@parentfinder.com',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
    },
    validateUrl (url) {
      return validateUrl(url);
    },
    deleteCard (card) {
      /* Delete the payment method */
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('PaymentMode', card.id);
            if (error) {
              console.log('error', error);
              swal.fire({
                type: 'warning',
                title: 'Error',
                text: `${error}, please try again. If problem persists please contact support at support@parentfinder.com`,
                showConfirmButton: true,
                onClose: () => {
                  return;
                }
              });
              return;
            } else {
              /* Remove from payment mode */
              let index = this.PaymentMode.findIndex(x => x.id === card.id);
              this.PaymentMode.splice(index, 1);
              this.setCards();
              this.setCardIcons();
              swal.fire(
                'Deleted!',
                'The selected card has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    editCard (card) {
      /* Edit the card */
    },
  }
};
</script>


<style scoped>
  table {
    border-collapse: collapse;
  }
  .dateRange >>> .v-menu {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Campaign/main.vue